/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_Contract_OffInputs */



/**
* | output |
* | --- |
* | "When the prepaid budget is used up, requests in the app fall back to the free model and requests through an API key or the Microsoft Teams bot are refused, u..." |
*
* @param {Usage_Overage_Contract_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_contract_off = /** @type {((inputs?: Usage_Overage_Contract_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Contract_OffInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ist das vorausbezahlte Budget verbraucht, nutzen Anfragen in der App das kostenlose Modell und Anfragen über einen API-Schlüssel oder den Microsoft-Teams-Bot werden abgelehnt, bis neues Guthaben hinzugefügt wird.")
	return /** @type {LocalizedString} */ ("When the prepaid budget is used up, requests in the app fall back to the free model and requests through an API key or the Microsoft Teams bot are refused, until more credit is added.")
});